/**
 * @file：挂号 request
 */

import {
  HospitalExperts,
  HospitalKeyDepartments,
  HospitalMedicalGuidelines,
  HospitalSummary,
  IDoctorScheduleDate,
  IDoctorSchedulePageInfo,
  IDoctorScheduleTimeSlot,
  IDoctorTitleInfo,
  IGetHospitalRecommendParams,
  IGetRecommendDoctorPageListParams,
  IParamsGetRegisterNotice,
  IPickedCityInfo,
  IPickerOption,
  IQueryWeekNumberSource,
  IRecommendDepartment,
  IRecommendHospital,
  IRegisterCity,
  IRegisterHospital,
  IRegisterTip,
  ISearchByDepartment,
  ISearchByHospital,
  ISearchByHospitalParams,
  ISearchResult,
  ITab,
  TypeQueryDoctorSchedulingList,
  TypeQueryJkzlDoctorSchedulingList
} from '@/schemas/register';
import { request } from './request';
import { ApiConfigs, Response, ResponseV2 } from '../schemas/service';

const api: ApiConfigs = {
  // @see https://kapi.corp.kuaishou.com/project/5058/interface/api/536025
  queryWeekNumberSource: {
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/register/queryWeekNumberSource',
    url: '/health/api/v1/register/queryWeekNumberSource',
    method: 'GET'
  },
  queryDoctorSchedulingDateList: {
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/register/queryDoctorSchedulingDateList',
    url: '/health/api/v1/register/queryDoctorSchedulingDateList',
    method: 'GET'
  },
  queryDoctorSchedulingTimeSlotList: {
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/register/queryDoctorSchedulingTimeSlotList',
    url: '/health/api/v1/register/queryDoctorSchedulingTimeSlotList',
    method: 'GET'
  },
  queryDoctorSchedulingList: {
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/register/queryDoctorSchedulingList',
    url: '/health/api/v1/register/queryDoctorSchedulingList',
    method: 'GET'
  },
  // 获取挂号须知 订单详情与下单页使用
  getHospitalRegisterNotice: {
    url: '/health/api/v1/register/hospitalRegisterNotice',
    method: 'GET'
  },

  /**  -----挂号v1.2新增需求----- */
  search: {
    url: '/health/api/v1/register/search',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/register/search',
    method: 'GET'
  },
  searchByDepartment: {
    url: '/health/api/v1/register/searchByDepartment',
    // url: 'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/register/searchByDepartment',
    method: 'GET'
  },
  queryJkzlDoctorSchedulingList: {
    url: '/health/api/v1/register/queryJkzlDoctorSchedulingList',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/register/queryJkzlDoctorSchedulingList',
    method: 'GET'
  },
  // 根据经纬度获取城市
  getCityByLocation: {
    url: '/health/api/v1/register/getCityByLocation',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/register/getCityByLocation',
    method: 'GET'
  },
  // 查询城市列表
  getCityList: {
    url: '/health/api/v1/register/getCityList',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/register/getCityList',
    method: 'GET'
  },
  // 挂号首页:按医院搜索时默认显示的医院
  getSearchByHospital: {
    url: '/health/api/v1/register/searchByHospital',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/register/searchByHospital',
    method: 'GET'
  },
  // 挂号首页: 获取推荐医院/曾就诊医院
  getHospitalRecommend: {
    url: '/health/api/v1/register/getHospitalRecommend',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/register/getHospitalRecommend',
    method: 'GET'
  },
  // 挂号首页:专家推荐tab科室获取
  getRecommendDepartmentList: {
    url: '/health/api/v1/register/getExpertRecommendTab',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/register/getExpertRecommendTab',
    method: 'GET'
  },
  // 挂号首页:推荐医生列表
  getRecommendDoctorPageList: {
    url: '/health/api/v1/register/getRecommendDoctorPageList',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/register/getRecommendDoctorPageList',
    method: 'GET'
  },
  getHospitalSummary: {
    url: '/health/api/v1/hospital/summary',
    method: 'GET'
  },
  getHospitalMedicalGuidelines: {
    url: '/health/api/v1/hospital/medical-guidelines',
    method: 'GET'
  },
  getHospitalKeyDepartments: {
    url: '/health/api/v1/hospital/key-departments',
    method: 'GET'
  },
  getHospitalExperts: {
    url: '/health/api/v1/hospital/experts',
    method: 'GET'
  }
};

const register = {
  async queryWeekNumberSource(queryData: {
    secondDepartmentId?: string;
    hospitalIndexId?: number;
  }) {
    const response: Response = await request(
      api.queryWeekNumberSource,
      queryData
    );
    const { result } = response;
    return result as {
      weekNumberSourceList: IQueryWeekNumberSource[];
    };
  },

  async queryDoctorSchedulingDateList({ hospitalDoctorId, hospitalIndexId }) {
    const response: Response = await request(
      api.queryDoctorSchedulingDateList,
      {
        hospitalDoctorId,
        hospitalIndexId
      }
    );
    const { result } = response;
    return result as {
      dateList: IDoctorScheduleDate[];
    };
  },

  async queryDoctorSchedulingTimeSlotList({
    schedulingId,
    hospitalIndexId,
    hospitalDoctorId
  }) {
    const response: Response = await request(
      api.queryDoctorSchedulingTimeSlotList,
      {
        schedulingId,
        hospitalIndexId,
        hospitalDoctorId
      }
    );
    const { result } = response;
    return result as {
      doctorSchedulingTimeSlotInfos: IDoctorScheduleTimeSlot[];
    };
  },

  async queryDoctorSchedulingList(queryData: TypeQueryDoctorSchedulingList) {
    console.log('queryData', queryData);
    const response: Response = await request(
      api.queryDoctorSchedulingList,
      queryData
    );
    const { result } = response;
    return result as {
      doctorInfoSet: IDoctorTitleInfo[];
      pageableResult: IDoctorSchedulePageInfo;
    };
  },
  async getHospitalRegisterNotice(payload: IParamsGetRegisterNotice) {
    const {
      hospitalDoctorId,
      hospitalIndexId,
      hospitalSecondDepartmentCode
    } = payload;

    const response: Response = await request(api.getHospitalRegisterNotice, {
      hospitalDoctorId,
      hospitalIndexId,
      hospitalSecondDepartmentCode
    });
    const { result } = response;
    // eg:  "result": "<li>1、请您来院就诊前通过微信、网站、支付宝、电话等方式进行预约，预约成功后再来院就诊。</li>\r\n<li>2、每晚8:00点开放号源，您可预约一周之内的号源。</li>\r\n<li>3、我院实行实名制就诊，来院就诊患者及家属请务必携带好个人身份证原件，凭身份证原件(童携带户口本)就诊，否则无法取预约号，只能作废预约。</li>\r\n<li>4、预约时请您填写有效的联系方式（最好是随身手机号），以方便您在就诊过程中能收到短信提示。</li>\r\n<li>5、预约成功后请于就诊当天提前30分钟到医院预约签到。山东省直医保患者、济南市医保患者首次预约者，请先到人工窗口绑定身份证后到护士站确认预约信息;其他患者到自助机建档充值、预约签到，过时重新排队。</li>\r\n<li>6、如遇特殊情况不能如约就诊时，请提前一天取消，否则视为违约。如果一个月内连续违约累计3次或同一账号一周内连续取消累计6次，系统将自动锁定，半年内无法预约;如果一天取消3次，则当日无法预约</li>\r\n<li>7、坐诊医生因应急、突发事件等原因可能会有变动，以当日实际坐诊医生为准，敬请谅解。</li>\r\n<li>8、电话预约0531-88197777，受理时间每天：8:00—17:00。</li>"
    if (result && result.registeredNotice) {
      return result as IRegisterTip;
    }
    return null;
  },

  // -----v1.2需求新增----- //
  async search({ areaCode, name, cityCode }) {
    const response: Response = await request(api.search, {
      areaCode,
      name,
      cityCode
    });
    const { result, code } = response;

    const target = transSearchResult(result, name);
    return target;
  },

  async searchByDepartment({ shortName }) {
    const response: Response = await request(api.searchByDepartment, {
      shortName
    });
    const { result } = response;
    return result as Record<string, Array<ISearchByDepartment>>;
  },

  async queryJkzlDoctorSchedulingList(
    queryData: TypeQueryJkzlDoctorSchedulingList | TypeQueryDoctorSchedulingList
  ) {
    const response: Response = await request(
      api.queryJkzlDoctorSchedulingList,
      queryData
    );
    const { result } = response;
    return result as {
      doctorInfoSet: IDoctorTitleInfo[];
      pageableResult: IDoctorSchedulePageInfo;
    };
  },

  // 根据经纬度获取城市
  async getCityByLocation({
    latitude,
    longitude
  }: {
    latitude: string;
    longitude: string;
  }) {
    let target: IPickedCityInfo = {
      cityCode: '',
      cityName: '北京',

      areaCode: '-1',
      areaName: '不限'
    };
    try {
      const response: Response = await request(api.getCityByLocation, {
        latitude,
        longitude
      });
      const { result } = response;
      target = {
        ...target,
        // TODO 后端只返回一级城市信息
        cityCode: result.cityCode,
        cityName: result.cityName
      };
      return target;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  // 获取可选城市列表
  // "result": [
  //   {
  //     "cityCode": "ex dolor deserunt",
  //     "cityName": "do dolore ut reprehenderit mollit",
  //     "countyList": [
  //       {
  //         "cityCode": "irure id occaecat sit in",
  //         "cityName": "sunt"
  //       },]
  //     }
  //   ]
  async getCityList() {
    const params = {};
    try {
      const response: Response = await request(api.getCityList, params);
      const { result } = response;
      let target: IPickerOption[] = [];
      if (result.length === 0 || !result) {
        return [];
      }
      target = result.map((item: IRegisterCity) => {
        const itemCity: IPickerOption = {
          value: item.cityCode,
          text: item.cityName,
          enableRegister: item.enableRegister ?? false,
          subGroup: []
        };
        if (item.countyList && item.countyList.length > 0) {
          itemCity.subGroup = item.countyList.map(
            (subItem) =>
              ({
                value: subItem.cityCode,
                text: subItem.cityName,
                enableRegister: subItem.enableRegister ?? false
              } as IPickerOption)
          );
        }
        return itemCity;
      });
      return target;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  // 挂号首页:按医院搜索时默认显示的医院
  async getSearchByHospital({
    cityCode,
    areaCode,
    hospitalLevel,
    latitude,
    longitude,
    name,
    sortFlag
  }: ISearchByHospitalParams) {
    try {
      const params = {
        cityCode,
        areaCode,
        hospitalLevel,
        latitude,
        longitude,
        name,
        sortFlag
      };
      const response: Response<ISearchByHospital[]> = await request(
        api.getSearchByHospital,
        params
      );
      const { result } = response;
      const target: ISearchByHospital[] = transSearchHospital(result, name);
      return target;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  // 挂号首页: 获取推荐医院/曾就诊医院
  async getHospitalRecommend(palyload: IGetHospitalRecommendParams) {
    const { cityCode, areaCode, latitude, longitude } = palyload;
    const params = {
      cityCode,
      areaCode,
      latitude,
      longitude
    };
    try {
      const response: Response = await request(
        api.getHospitalRecommend,
        params
      );
      const { result } = response;
      const target: IRegisterHospital[] = transRecommendHospitalData(result);
      return target;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  // 挂号首页:专家推荐tab科室获取
  async getRecommendDepartmentList() {
    try {
      // tab组件渲染用
      let renderTabData: ITab[] = [];
      // 根据选中tab查询推荐医生时使用, 需要 根据选中的tab反查department信息
      const departmentMap: {
        [key: string]: IRecommendDepartment;
      } = {};

      const response: Response = await request(api.getRecommendDepartmentList);
      const { result } = response;
      if (result) {
        renderTabData = result.map((item: IRecommendDepartment) => {
          const itemTarget: ITab = {
            key: `${item.departmentId}`,
            value: item.departmentName
          };
          return itemTarget;
        });
        result.forEach((item: IRecommendDepartment) => {
          departmentMap[item.departmentId] = item;
        });
      }

      return {
        renderTabData,
        departmentMap
      };
    } catch (error) {
      return Promise.reject(error);
    }
  },

  // 挂号首页获取推荐医生列表
  async getRecommendDoctorPageList(payload: IGetRecommendDoctorPageListParams) {
    const {
      areaCode,
      cityCode,
      departmentName,
      shortName,
      pageNum,
      pageSize
    } = payload;
    const params = {
      areaCode,
      cityCode,
      departmentName,
      shortName,
      pageNum,
      pageSize
    };
    try {
      const response: Response = await request(
        api.getRecommendDoctorPageList,
        params
      );
      const {
        result: { pageableResult }
      } = response;
      return pageableResult;
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async getHospitalSummary(hospitalIndexId: number) {
    try {
      const response: ResponseV2<HospitalSummary> = await request(
        api.getHospitalSummary,
        {
          hospitalIndexId
        }
      );
      const { data } = response;

      return transSummary(data);
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async getHospitalMedicalGuidelines(hospitalIndexId: number) {
    try {
      const response: ResponseV2<HospitalMedicalGuidelines> = await request(
        api.getHospitalMedicalGuidelines,
        { hospitalIndexId }
      );
      const { data } = response;
      return data;
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async getHospitalKeyDepartments(hospitalIndexId: number) {
    try {
      const response: ResponseV2<HospitalKeyDepartments> = await request(
        api.getHospitalKeyDepartments,
        { hospitalIndexId }
      );
      const { data } = response;
      return transKeyDepartments(data);
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async getHospitalExperts(hospitalIndexId: number) {
    try {
      const response: ResponseV2<HospitalExperts> = await request(
        api.getHospitalExperts,
        {
          hospitalIndexId
        }
      );
      const { data } = response;
      return data;
    } catch (err) {
      return Promise.reject(err);
    }
  }
};

// 推荐医院数据整理, 曾就诊医院列表和附近医院列表整合为一个表, 增就诊医院排在首位
const transRecommendHospitalData = (
  data: IRecommendHospital = {
    visitedHospitalList: [],
    nearHospitalList: []
  }
) => {
  const { visitedHospitalList = [], nearHospitalList = [] } = data;
  const visitedData: IRegisterHospital[] = visitedHospitalList.map((item) => ({
    ...item,
    isVisited: true
  }));
  const visitiedHospitalIds = visitedHospitalList.map(
    (item) => item.hospitalIndexId
  );
  const nearData: IRegisterHospital[] = [];
  // 访问过的医院和附近医院可能有重复
  nearHospitalList.forEach((item) => {
    if (!visitiedHospitalIds.includes(item.hospitalIndexId)) {
      nearData.push(item);
    }
  });
  return [...visitedData, ...nearData];
};

// 综合搜索结果数据转换
const transSearchResult = (data, keyword: string) => {
  const { departmentList = [], hospitalList = [] } = data;
  const searchDepartmentList: ISearchResult[] = (departmentList || []).map(
    (item) => {
      const newItem: ISearchResult = {
        // hospitalIndexId: item.hospitalIndexId,
        // departmentId: item.hospitalSecondDepartmentCode,
        departmentName: item.secondClassification, // 二级科室名字
        shortName: item.shortName, // 科室简称
        showName: transHighlightWord(item.secondClassification, keyword),
        enableRegister: item.enableRegister
        // joinType: item.joinType,
      };
      return newItem;
    }
  );

  const searchHospitalList: ISearchResult[] = (hospitalList || []).map(
    (item: ISearchByHospital) => {
      const newItem: ISearchResult = {
        hospitalIndexId: item.hospitalIndexId,
        hospitalName: item.hospitalName,
        // showName: item.hospitalName,
        showName: transHighlightWord(item.hospitalName, keyword),
        enableRegister: item.enableRegister
        // joinType: item.joinType,
      };
      return newItem;
    }
  );

  return [...searchHospitalList, ...searchDepartmentList];
};

const transSearchHospital = (
  data: ISearchByHospital[],
  keyword: string | undefined
) => {
  const searchHospitals: ISearchByHospital[] = data.map((item) => {
    const newItem: ISearchByHospital = {
      ...item,
      showHospitalName: transHighlightWord(item.hospitalName, keyword)
    };
    return newItem;
  });
  return searchHospitals;
};

// 高亮搜索关键词
const transHighlightWord = (name: string, keyword: string | undefined) => {
  if (!keyword) {
    return name;
  }
  return name.split(keyword).join(`<i style="color: #FE3666">${keyword}</i>`);
};

const transSummary = (summary: HospitalSummary) => {
  const historyList =
    summary.history === ''
      ? []
      : summary.history.split('</p><p>').map((info) => {
          const text = info.replace(/(<p>|<\/p>)/g, '');
          const time = text.substring(
            text.search(/[0-9]{4}年([0-9]{1,2}月)?([0-9]{1,2}日)?，/),
            text.indexOf('，')
          );
          const event = text.replace(
            /[0-9]{4}年([0-9]{1,2}月)?([0-9]{1,2}日)?，/,
            ''
          );
          return { time, event };
        });
  return {
    ...summary,
    hospitalInfo: {
      ...summary.hospitalInfo,
      introduction: summary.hospitalInfo.introduction.replace(
        /(<p>|<\/p>)/g,
        ''
      )
    },
    historyList
  };
};

const transKeyDepartments = (keyDepartments: HospitalKeyDepartments) => {
  return {
    departments: keyDepartments.departments.replace(/(<p>|<\/p>)/g, ''),
    specialDepartments: keyDepartments.specialDepartments
      .split('</p><p>')
      .map((text) => text.replace(/(<p>|<\/p>)/g, '').split('：'))
  };
};

export default register;
